<template>
  <div class="c-login-container">
    <div class="c-login-header">
      <div class="logo">
        <p class="img" @click="handleLogoClick"></p>
        智慧社区数据可视化平台
      </div>
    </div>
    <div class="bg">
      <div class="login-area">
        <div class="header">欢迎登录</div>
        <div class="form">
          <div class="form-item">
            <el-input
                placeholder="用户名"
                v-model.trim="phone"
                :maxlenth="11">
              <img slot="prefix" class="c-ip-img" src="~@/assets/image/login-user-icon.png" alt="">
            </el-input>
          </div>
          <div class="form-item">
            <el-input
                placeholder="密码"
                type="password"
                @keyup.enter.native="login"
                v-model="pwd"
                :maxlength="16">
              <img slot="prefix" class="c-ip-img" src="~@/assets/image/login-psw-icon.png" alt="">
            </el-input>
          </div>
        </div>
        <div class="footer">
          <div class="about-process"><span @click="handleSetPwdClick">忘记密码</span></div>
          <el-button type="button" @click="login">登 录</el-button>
        </div>
      </div>
    </div>
    <div class="c-login-footer">
      <div>2018 | 比亦特网络科技(天津)有限公司 津ICP备16009153号-3</div>
    </div>
  </div>
</template>
<script>
  import {  getUri } from '@/utils/oss'
  import host from '@/api/host'
  export default {
    data(){
      return {
        communityList: [],
        dialogVisible: false,
        phone: null,
        pwd: null,
      }
    },
    methods: {
      login(){
        if(!this.$VLD.required(this.phone)) {
          this.$VLD.showMsg('请输入手机号码')
          return false;
        }
        if(!this.$VLD.isPhone(this.phone)){
          this.$VLD.showMsg('请输入正确的手机号码')
          return false;
        }
        if(!this.$VLD.required(this.pwd)) {
          this.$VLD.showMsg('请输入密码')
          return false;
        }
        this.$http('userLogin', {
          phone:  this.phone,
          pwd: this.pwd
        }).then(async res => {
          if (!res.errorCode) {
            if(res.data.headImg) {
              res.data.headImg = await getUri(res.data.headImg)
            }
            this.$store.dispatch('updateUserInfo', res.data);
            this.$store.commit('SET_SUGGESTIONS_TIME', null);
            this.getCommunityList();
          }
        })
      },
      async getCommunityList(userId){
        const list = await this.$store.dispatch('getCommunityList');
        if( !list || !Array.isArray(list) ) {
          return false;
        }
        if(list.length === 0) {
          //提示暂无社区
          return false;
        }
        else if(list.length === 1) {
          //进入当前社区
          this.$store.dispatch('updateCurrentCommunity', list[0]);
          this.getbusCommunity();
          
        }
        else {
          const preCommunityList = this.$store.state.user.communityList;
          const contrast = {}
          if(preCommunityList) {
            this.$store.state.user.communityList.map( item => { contrast[item.id] = true } )
          }
          const isDiff = list.some( item => !contrast[item.id] )
          //跳转到社区选择页
          if(isDiff) {
            //清除currentCommunity
            this.$store.dispatch('updateCurrentCommunity');
            this.$router.push({ name: 'switchCommunity' });
          }
          //直接进入主页面
          else {
            this.getbusCommunity();
          }
        }
        this.$store.dispatch('updateCommunityList', list)
      },
      //获取社区详情
      getbusCommunity(){
        this.$http(['busCommunity', this.$store.getters.communityId]).then(async res => {
          if(!res.errorCode) {
            this.detail = res.data;
            this.$store.dispatch('updateCurrentCommunityDetail', res.data);
            this.$router.push({ name: 'home' });
          }else{
              Message({ message: '未能获取到社区详情，请稍后再试', type: 'error' });
          }
        }).catch(err => {})
      },
      handleLogoClick(){
        window.location.reload()
      },
      handleSetPwdClick(){
        this.$router.push({ name: 'setPwd' })
      }
    },
  }
</script>
<style lang="scss" scoped>
  @import "~@/assets/style/mixins";
  .c-login-container {
    width: 100%;
    height: 100%;
    min-width: 1320px;
    min-height: 630px;
  }
  .c-login-header {
    width: 100%;
    height: 66px;
    background-color: #fff;
    display: flex;
    align-items: center;
    .logo {
      color: #666666;
      font-size: 19px;
      font-weight:400;
      margin-left: 250px;
      display: flex;
      align-items: center;
      @include hoverPointer;
    }
    .img {
      display: block;
      width: 30px;
      height: 35px;
      margin-right: 12px;
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAjCAYAAACD1LrRAAAFeElEQVRYR7WXe4jUVRTHP+femZ01Q8tEI0vLSDSNMkhMCLISrURRK9Py2cPV+a2ZqT0gsjKosJc7s27ro9IEH5VmREmmqNkiRVLqH6JIFGpG5WN9rDO/3z3xm5ldHd3RSaf738zv3PP5nfO995zzE0q94sFUhFdQDiGyHfRLUmYRtXL4dJSUmsuT2paY3w1fWmHlNpDhqLbFmOlUyYeNvNKDQ8+V2oo/OMYKCUAFjwngZqPMIWlfCE1KD56sg3FuFXAIlQ2IP4tE2Y9UpHoSsZtQnUIyMv/CwHH/IcTMxumbVNtEnlwz1bD/5PVEYx0Q9wjKeCBOwtbg+Y+C1KCm038DP6hltHfvAJNOwWQFIo9TJUea/vP0Kg5zmMVyDM8fBvIJzt1BdfQ7PPcTqquKB0/UzlhdAXprBqDsReiQg+3CN0Opke08rS1Iu4PAcVQrSEaWE/drEHMtCTMAL3gadGRx4Lg/CqQKoXUONJuEmUHcPZ+5OmBRGlCmZ1I/Vstp6cYBb9NgOtCCzuDqcOZy4BbErTk3eJq2pCGT2idyUf6JmLEk5Cu8dH8ORNbSzu+F2KWgHTM2wnL8+grmXnYQz99C4I+mPPYbKf2CEzKEchTjnikMjmsXxH0OdM1GqRvAjiRVn6Ls0gWgg1D9gcA+hKUedAGig3Mv+CvGDKVKthaqE82DJwUTMLwFtAQcyksk7SwmaR/ELUW45jSHh0ArSUQ+zurH60AZcBJlBkk7pzl4PniUtqRV8D4ij+SM96HmAZJSRzwI9ZwFmAJRzOOomUx5uhsRuxLolI1eP+WEHcdCqW++ZMa1O+I+A7rkNmxE7AhSpIgGHyAysIjyuoPADMPwFwSLELkvl/rdOH8Yc2O/5JdML6gE3gBaZFILM0nYV4mnb0fMcuDqIqC5o8BxYBpJOxcveA5lFoIFGhDzLFWSSb3gBR8Bo3Nv9jtqHqZavscLZgCvAZGioacbKktImzhRuiK6DDSbelhEwo4RPPc3aBvQ1agdT4DF6keIDigATCOsxJk1SHAMpBswErjhLHtlDxIMJxrdQ0oXZk+9/ENC2goVJ3tg7Q0kIyt5SjsSuDrgqmahoSPMINL8Q4yBONcGY7ayjXV0dy8jZDrPGSuN01FUR5YR94cQBLuoiW3PP9We3gXu2wLQBtLpHsRivVA3L3fVcqayCSf3YdzbTcUm38l7JOyU5k91+K+XvhPM+gIpfhNrFhK47c3qrroEZysxbh9CeZ4P5V2SNrzjTeuMiM8BVtcHMaGWXna3bAFdCHRECZ22wJj2qC4G7V86sJ+6jkisGvTeTFXCdIagFpH1pMxqom4FznmIeQxhbOnAGvQGOwZhIko9xvRE3e5c9JtRGc8R9tI6WAVyT+nAmTvtL0MjPyOZkWk6uB/BLAPaAceAF1HzJWgNon2b4Belceg4ZW6kLOgHUp1rBDU4MwfjQvhNWZDWEfjjMLHeiAsbzRVcJDicOnZizP1o2LHcEOBKxCzmALtpH7wHku3bkM7A1NRi3NfAahJ26oWd6lO7TgBLcfoNcBSI4tuNROkFfn8wlTkpwpO/kbRMJMogEhK2ywu4TgUuNzAVtAtIRc5E88dmWUdCQnnC5lNCcGC6Yt26gmU2IzvzSdpGGbJVIC+Qc1eus2NW/kJML3B7Ciek6ckEEra28ddFgjM6L0ZkURHgkwTpm5lbvvPsiON6N+LWFuGkUc7VIJtzQ0Qx27bhTB+q5Wh+xE/qJUSCESDFNX9j9iPUoTo/M3Webyk7SJt+1Mr+4gb68zkMn09K98WY2UD2S+PMpXyYmUhqJRyN/oevxbg/BpFwGm2c08JiEs5geWNu6SI+PcJQsqgLK9U4MCNJhi00f/0LSlw1HWjX8/UAAAAASUVORK5CYII=") no-repeat 0 0;
      background-size: cover;
    }
  }
  .bg {
    width: 100%;
    height: calc(100% - 180px);
    background: url('~@/assets/image/login-bg.png') no-repeat 0 0;
    background-size: cover;
    position: relative;
  }
  .login-area {
    position: absolute;
    top: 50%;
    right: 217px;
    transform: translateY(-50%);
    width: 370px;
    height: 330px;
    background-color: #fff;
    padding: 40px;
    .header {
      color: #333;
      font-size: 18px;
      font-weight:bold;
    }
    .form {
      padding-top: 20px;
      .form-item {
        margin-top: 20px;
      }
    }
    .footer {
      .about-process {
        font-size:14px;
        font-weight:500;
        color: #C2C2C2;
        text-align: right;
        padding-top: 10px;
        span {
          @include hoverPointer;
        }
      }
      button {
        background-color: #006CFD;
        width: 100%;
        height: 44px;
        color: #fff;
        font-size: 14px;
        border-radius: 4px;
        margin-top: 20px;
        @include hoverPointer;
      }
    }
  }

  .c-login-footer {
    height: 114px;
    font-size: 13px;
    color: #c6c6c6;
    text-align: center;
    padding-top: 30px;
  }

  .c-ip-img {
    width: 15px;
    height: 17px;
    margin-top: 10px;
    margin-left: 5px;
  }

</style>